import React from "react";

// Small, recognizable card-network marks used only to indicate accepted
// payment methods (standard merchant practice) -- not pixel-accurate
// reproductions of any brand's official logo file.
export function VisaMark({ className = "" }) {
  return (
    <svg viewBox="0 0 48 32" className={className} role="img" aria-label="Visa">
      <rect width="48" height="32" rx="4" fill="#1A1F71" />
      <text x="24" y="21" textAnchor="middle" fontFamily="Arial, sans-serif" fontStyle="italic" fontWeight="700" fontSize="13" fill="#FFFFFF">VISA</text>
    </svg>
  );
}

export function MastercardMark({ className = "" }) {
  return (
    <svg viewBox="0 0 48 32" className={className} role="img" aria-label="Mastercard">
      <rect width="48" height="32" rx="4" fill="#F4F4F4" />
      <circle cx="20" cy="16" r="9" fill="#EB001B" />
      <circle cx="28" cy="16" r="9" fill="#F79E1B" />
      <path d="M24 9a9 9 0 0 1 0 14 9 9 0 0 1 0-14Z" fill="#FF5F00" />
    </svg>
  );
}

export function AmexMark({ className = "" }) {
  return (
    <svg viewBox="0 0 48 32" className={className} role="img" aria-label="American Express">
      <rect width="48" height="32" rx="4" fill="#2E77BC" />
      <text x="24" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="10.5" fill="#FFFFFF">AMEX</text>
    </svg>
  );
}

export function DiscoverMark({ className = "" }) {
  return (
    <svg viewBox="0 0 48 32" className={className} role="img" aria-label="Discover">
      <rect width="48" height="32" rx="4" fill="#1B1B1B" />
      <text x="20" y="20" textAnchor="middle" fontFamily="Arial, sans-serif" fontWeight="700" fontSize="9" fill="#FFFFFF">DISC</text>
      <circle cx="40" cy="16" r="7" fill="#F68121" />
    </svg>
  );
}

export function PayPalMark({ className = "" }) {
  return (
    <svg viewBox="0 0 90 24" className={className} role="img" aria-label="PayPal">
      <text x="0" y="19" fontFamily="Arial, sans-serif" fontWeight="700" fontStyle="italic" fontSize="19">
        <tspan fill="#003087">Pay</tspan><tspan fill="#009cde">Pal</tspan>
      </text>
    </svg>
  );
}

export function CardBrandRow({ className = "" }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <VisaMark className="h-5 w-8" />
      <MastercardMark className="h-5 w-8" />
      <AmexMark className="h-5 w-8" />
      <DiscoverMark className="h-5 w-8" />
    </div>
  );
}
